import { useMemo } from 'react'
import { useFirestoreQuery } from '../../../../../firebase/useFirestore'
import usePersonaReadFailure from './usePersonaReadFailure'

// De beoordelingen arbeidsvaardigheden van de deelnemer van het rapport, in de
// app. Een eigen hook zodat de widget op de openbare link dezelfde weergave
// kan voeden met `personaData.workSkills` (publicWorkSkillsState).
// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure

/** @typedef {'idle' | 'loading' | 'error' | 'missing' | 'ready'} PersonaWorkSkillsStatus */

/**
 * @param {string|null} personaId - Uit useWidgetPersona; `null` = niets lezen
 * @returns {{ status: PersonaWorkSkillsStatus, assessments: Array<object> }}
 */
const usePersonaWorkSkills = (personaId) => {
    const { failed, onError } = usePersonaReadFailure(personaId)

    const docs = useFirestoreQuery('WorkSkillsAssessments', {
        where: [['PersonaID', '==', personaId || '']],
        enabled: !!personaId,
        onError,
    })

    return useMemo(() => {
        if (!personaId) return { status: 'idle', assessments: [] }
        if (failed) return { status: 'error', assessments: [] }
        // '' = nog niet geladen (de begintoestand van useFirestoreQuery).
        if (!Array.isArray(docs)) return { status: 'loading', assessments: [] }
        return { status: 'ready', assessments: docs }
    }, [personaId, failed, docs])
}

export default usePersonaWorkSkills
